import { createAction } from 'redux-act';

const applyAttendanceCorrectionRequest = createAction('APPLY_ATTENDANCE_CORRECTION_REQUEST', data => data);
const applyAttendanceCorrectionSuccess = createAction('APPLY_ATTENDANCE_CORRECTION_SUCCESS', data => data);
const applyAttendanceCorrectionError = createAction('APPLY_ATTENDANCE_CORRECTION_ERROR');

const getAttendanceCorrectionRequestDataRequest = createAction('GET_ATTENDANCE_CORRECTION_REQUESTS_DATA_REQUEST', data => data);
const getAttendanceCorrectionRequestDataSuccess = createAction('GET_ATTENDANCE_CORRECTION_REQUESTS_DATA_SUCCESS', data => data);
const getAttendanceCorrectionRequestDataError = createAction('GET_ATTENDANCE_CORRECTION_REQUESTS_DATA_ERROR');

const approveRejectAttendanceCorrectionRequest = createAction('APPROVE_REJECT_ATTENDANCE_CORRECTION_REQUEST', data => data);
const approveRejectAttendanceCorrectionSuccess = createAction('APPROVE_REJECT_ATTENDANCE_CORRECTION_SUCCESS', data => data);
const approveRejectAttendanceCorrectionError = createAction('APPROVE_REJECT_ATTENDANCE_CORRECTION_ERROR');

const getAttendanceCorrectionApprovalRequest = createAction('GET_ATTENDANCE_CORRECTION_APPROVAL_REQUEST', data => data);
const getAttendanceCorrectionApprovalSuccess = createAction('GET_ATTENDANCE_CORRECTION_APPROVAL_SUCCESS', data => data);
const getAttendanceCorrectionApprovalError = createAction('GET_ATTENDANCE_CORRECTION_APPROVAL_ERROR');

const updateAttendanceLogRequest = createAction('UPDATE_ATTENDANCE_LOG_REQUEST', data => data);
const updateAttendanceLogSuccess = createAction('UPDATE_ATTENDANCE_LOG_SUCCESS', data => data);
const updateAttendanceLogError = createAction('UPDATE_ATTENDANCE_LOG_ERROR');

const getAttendanceLogsRequest = createAction('GET_ATTENDANCE_LOGS_REQUEST', data => data);
const getAttendanceLogsSuccess = createAction('GET_ATTENDANCE_LOGS_SUCCESS', data => data);
const getAttendanceLogsError = createAction('GET_ATTENDANCE_LOGS_ERROR');

const attendanceCorrectionLogsRequest = createAction('ATTENDANCE_CORRECTION_LOGS_REQUEST', data => data);
const attendanceCorrectionLogsSuccess = createAction('ATTENDANCE_CORRECTION_LOGS_SUCCESS', data => data);
const attendanceCorrectionLogsError = createAction('ATTENDANCE_CORRECTION_LOGS_ERROR');

const correctionFormData = createAction('CORRECTION_FORM_DATA_SUCCESS', data => data);
const handleClearCorrectionRequest = createAction('HANDLE_CLEAR_CORRECTION_REQUEST')

export default {
    applyAttendanceCorrectionRequest,
    applyAttendanceCorrectionSuccess,
    applyAttendanceCorrectionError,

    getAttendanceCorrectionRequestDataRequest,
    getAttendanceCorrectionRequestDataSuccess,
    getAttendanceCorrectionRequestDataError,

    approveRejectAttendanceCorrectionRequest,
    approveRejectAttendanceCorrectionSuccess,
    approveRejectAttendanceCorrectionError,

    getAttendanceCorrectionApprovalRequest,
    getAttendanceCorrectionApprovalSuccess,
    getAttendanceCorrectionApprovalError,

    updateAttendanceLogSuccess,
    updateAttendanceLogError,
    updateAttendanceLogRequest,

    getAttendanceLogsSuccess,
    getAttendanceLogsError,
    getAttendanceLogsRequest,

    attendanceCorrectionLogsSuccess,
    attendanceCorrectionLogsError,
    attendanceCorrectionLogsRequest,

    correctionFormData,

    handleClearCorrectionRequest
}